export default "__VITE_ASSET__B$EIhcUx__"